import React from 'react'
import { useWillPipe } from '@morningtrain/react-helpers'
import useCartContent from 'services/cart/hooks/use-cart-content'
import denomination from 'support/helpers/denomination'

export default function CheckoutEventOnPipe () {
  const format = denomination
  const cartContent = useCartContent()

  useWillPipe(payload => new Promise(resolve => {
    if (window.dataLayer) {
      const products = []

      for (const row of cartContent.entries()) {
        products.push({
          id: row[1].get('id'),
          name: row[1].get('domain'),
          price: format(row[1].get('discounted_price')),
          quantity: row[1].get('quantity')
        })
      }

      window.dataLayer.push({
        event: 'checkout',
        ecommerce: {
          checkout: {
            // 'actionField': {'step': 1, 'option': 'Visa'},
            products: products
          }
        }
      })
    }

    resolve(payload)
  }), [cartContent])

  return null
}
